// extracted by mini-css-extract-plugin
export default {"root":"WzBNrJqWKBk0lKiZo1gx","title":"Qg3UQxqbXehf1zADfuMP","placeHolderShimmer":"p4nhqlfOsLvCSkw7QlbU"};